import { RcTrans } from '@/components/atoms/RcTrans'
import { useChatMessageRevisions } from '@/entity/chat/useChatMessageRevisions'
import { ChatMessage } from '@/entity/chat/useChatMessages'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { PropsWithChildren, useState } from 'react'
import { ChatMessageText } from './ChatMessageText'
import { isEmpty, some } from 'lodash-es'

export const ChatMessageHistory = ({
  isChatAdmin,
  chatMessage,
  chatId,
  children
}: PropsWithChildren<{
  isChatAdmin?: boolean
  chatMessage: ChatMessage
  chatId: string
}>) => {
  const [shouldLoad, setShouldLoad] = useState(false)
  const { revisions } = useChatMessageRevisions({
    idOrKey: chatId,
    messageId: chatMessage.uid,
    paused: shouldLoad,
    suspense: false
  })

  const content = (
    <Typography
      variant='body2'
      color='info'
      onMouseOver={e => isChatAdmin && setShouldLoad(true)}
    >
      {children}
    </Typography>
  )

  if (isEmpty(revisions?.content)) {
    return content
  }

  const tooltipTitle = (
    <Stack direction='column' spacing={1}>
      {revisions?.content.map(it => (
        <ChatMessageText key={it.uid} message={it} />
      ))}
    </Stack>
  )

  return (
    <Tooltip placement='top-start' title={tooltipTitle}>
      {content}
    </Tooltip>
  )
}
